import * as React from 'react';

export function SvgFacebook(props: any) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 12C24 5.37264 18.6274 0 12 0C5.37264 0 0 5.37264 0 12C0 17.6275 3.87456 22.3498 9.10128 23.6467V15.6672H6.62688V12H9.10128V10.4198C9.10128 6.33552 10.9498 4.4424 14.9597 4.4424C15.72 4.4424 17.0318 4.59168 17.5685 4.74048V8.06448C17.2853 8.03472 16.7933 8.01984 16.1822 8.01984C14.2147 8.01984 13.4544 8.76528 13.4544 10.703V12H17.3741L16.7006 15.6672H13.4544V23.9122C19.3963 23.1946 24.0005 18.1354 24.0005 12H24Z"
        fill="#0866FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7001 15.6672L17.3735 12H13.4539V10.703C13.4539 8.76526 14.2142 8.01982 16.1817 8.01982C16.7927 8.01982 17.2847 8.0347 17.5679 8.06446V4.74046C17.0313 4.59118 15.7195 4.44238 14.9591 4.44238C10.9492 4.44238 9.10074 6.3355 9.10074 10.4198V12H6.62634V15.6672H9.10074V23.6467C10.0291 23.8771 11.0001 24 11.9995 24C12.4915 24 12.9767 23.9697 13.4534 23.9121V15.6672H16.6996H16.7001Z"
        fill="white"
      />
    </svg>
  );
}
